import $ from "jquery";

$('.test_popup_trigger').on('click', function(){
 $('.test_popup_box').fadeIn(500);
 $('.test_popup_trigger').fadeOut(10);
});


$('.test_popup_close').on('click', function(){
  $('.test_popup_box').fadeOut(500);
  $('.test_popup_trigger').fadeIn(10);
 });